import {i18n} from "../translate/i18n";

export const formatStatus = (status) => {

    switch (status) {
        case "draft":
            return {
                label: 'Respondente',
                color: "warning",
                icon: "bi-pen",
                statusQuery: status
            }
        case "draft_en":
            return {
                label: 'Tradutor',
                color: "warning",
                icon: "bi-translate",
                statusQuery: status
            }
        case "approval_esg":
            return {
                label: 'Aprovação - Líder ESG',
                color: "info",
                icon: "bi-hand-thumbs-up",
                statusQuery: status
            }
        case "evaluation_avesso":
            return {
                label: 'Avaliação - Avesso',
                color: "warning",
                icon: "bi-clipboard2-check",
                statusQuery: status
            }
        case "evaluation_suzano":
        case "evaluation_suzano_en":
            return {
                label: 'Avaliação - Suzano',
                color: "info",
                icon: "bi-clipboard2-check",
                statusQuery: status
            }
        case "finished":
            case "finished_en":
            return {
                label: 'Publicado',
                color: "success",
                icon: "bi-check-all",
                statusQuery: status
            }
        default:
            return {
                label: i18n.t(`header.${status}`),
                color: "danger",
                icon: "bi-eye-slash",
                statusQuery: ''
            }
    }
}


const statusGoals  = (status) => {

    switch (status) {
    case "draft_pt":
        return {
            label: 'Respondente',
            color: "warning",
            icon: "bi-pen",
        }
    case "draft_en":
        return {
            label: 'Tradutor',
            color: "warning",
            icon: "bi-translate",
        }
    case "approved_pt":
        case "approved_en":

            return {
            label: 'Aguardando Aprovação',
            color: "info",
            icon: "bi-hand-thumbs-up",
        }

    case "finished_pt":
    case "finished_en":
        return {
            label: 'Publicado',
            color: "success",
            icon: "bi-check-all",
        }
    default:
        return {
            label: 'Ocultados',
            color: "danger",
            icon: "bi-eye-slash",
        }
    }
}

export const statusGoalsList = [
    {
        status: 'draft_pt',
        label: 'Rascunho',
        icon: 'bi-pen',
        iconColor: 'warning',
        language: 'pt-BR',
    },
    {
        status: 'approved_pt',
        label: 'Aguardando aprovação',
        icon: 'bi-hand-thumbs-up',
        iconColor: 'info',
        language: 'pt-BR',
    },
    {
        status: 'finished_pt',
        label: 'Publicado',
        icon: 'bi-check-all',
        iconColor: 'success',
        language: 'pt-BR',
    },
    {
        status: 'draft_en',
        label: 'Tradutor',
        icon: 'bi-translate',
        iconColor: 'warning',
        language: 'en-US',
    },
    {
        status: 'approved_en',
        label: 'Aguardando aprovação',
        icon: 'bi-hand-thumbs-up',
        iconColor: 'info',
        language: 'en-US',
    },
    {
        status: 'finished_en',
        label: 'Publicado',
        icon: 'bi-check-all',
        iconColor: 'success',
        language: 'en-US',
    }

]

export const formatStatus2= (status) => {

    switch (status) {
        case "draft_pt":
            return {
                label: 'Respondente',
                color: "warning",
                icon: "bi-pen",
            }
        case "draft_en":
            return {
                label: 'Tradutor',
                color: "warning",
                icon: "bi-translate",
            }
        case "approved_pt":
        case "approved_en":

            return {
                label: 'Aguardando Aprovação',
                color: "info",
                icon: "bi-hand-thumbs-up",
            }

        case "finished_pt":
        case "finished_en":
            return {
                label: 'Publicado',
                color: "success",
                icon: "bi-check-all",
            }
        default:
            return {
                label: 'Ocultados',
                color: "danger",
                icon: "bi-eye-slash",
            }
    }
}


